// 🔧 use_vote_confirmation.js
// ✅ Purpose: Retrieve and clear temporary vote confirmation data
// ✅ Features:
// - Uses browser_storage_helpers
// - Reads one-time vote confirmation
// - Clears automatically after display
// - No direct localStorage usage

import { useEffect, useState } from "react";
import {
  SESSION_KEYS,
  getSessionValue,
  removeSessionValue,
} from "../utils/browser_storage_helpers";

export const useVoteConfirmation = () => {
  const [confirmation, setConfirmation] = useState(null);

  useEffect(() => {
    const stored = getSessionValue(
      SESSION_KEYS.VOTE_CONFIRMATION
    );

    if (!stored) return;

    try {
      const parsed =
        typeof stored === "string"
          ? JSON.parse(stored)
          : stored;

      setConfirmation(parsed);

      const timer = setTimeout(() => {
        removeSessionValue(
          SESSION_KEYS.VOTE_CONFIRMATION
        );
        setConfirmation(null);
      }, 10000);

      return () => clearTimeout(timer);
    } catch {
      removeSessionValue(
        SESSION_KEYS.VOTE_CONFIRMATION
      );
    }
  }, []);

  return confirmation;
};